import { PriceMoney } from "@/modules/location";

export class TabItemModifier {
  name: string = "";
  price: string = new PriceMoney({ amount: 0 }).getPricePackage();
  quantity: number = 0;
  constructor(data) {
    this.name = data.name;
    this.price = new PriceMoney({ amount: data.price }).getPricePackage();
    this.quantity = data.quantity;
  }
}
